import ibotsImg from '../images/ibots.png';
import College from '../images/clg.jpeg';
import School from '../images/sch.jpeg';
import School1 from '../images/schl.jpeg';
import p1 from '../images/Iot.jpg';
import p2 from '../images/deep fake.jpg';
import p3 from '../images/house.jpg';
import p4 from '../images/e-commerce.jpg';
import p5 from '../images/e-dashboard.jpg';
import p6 from '../images/aombile app.jpg';
import p7 from '../images/m-dashboard.jpg';
import p8 from '../images/payment.jpg';
import p9 from '../images/hostel.jpg';
import p10 from '../images/system.jpg';
import p11 from '../images/drowining.jpg';
import p12 from '../images/diabetes.jpg';
import p13 from '../images/crop.jpg';
import DB from '../images/db.png';
import AS from '../images/as.png';
import XML from '../images/images.png';
import Vercel from '../images/ver.png';
// import ReactLogo from 'react-logo.svg';
// import NodeLogo from 'nodejs-logo.svg';

export const Bio = {
  name: "Baranidharan B",
  roles: [
    "Full stack developer",
    "Software Developer",
    "AI & ML Enthusiast",
    "Web Developer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning, I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/Baranidharan911",
  resume:
    "https://drive.google.com/file/d/1WCy5F38nMf7fAledyNEU9qBgIq1Whh9U/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/baranidharan-b-3a3186247/",
  email: "bbharanidharan43@gmail.com",
  insta: "https://www.instagram.com/barani_dharan._/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg", // URL-based image
      },
      {
        name: "Next Js",
        image: "https://upload.wikimedia.org/wikipedia/commons/8/8e/Nextjs-logo.svg", // URL-based image
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png", // URL-based image
      },
      {
        name: "CSS",
        image: "https://upload.wikimedia.org/wikipedia/commons/d/d5/CSS3_logo_and_wordmark.svg", // URL-based image
      },
      {
        name: "JavaScript",
        image: "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png", // URL-based image
      },
      {
        name: "Bootstrap",
        image: "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png", // URL-based image
      },
      {
        name: "Material UI",
        image: "https://mui.com/static/logo.png", // URL-based image
      },
      {
        name: "Flutter",
        image: "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png", // URL-based image
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg", // URL-based image
      },
      {
        name: "Express Js",
        image: "https://upload.wikimedia.org/wikipedia/commons/6/64/Expressjs.png", // URL-based image
      },
      {
        name: "Python",
        image: "https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg", // URL-based image
      },
      {
        name: "Flask",
        image: "https://upload.wikimedia.org/wikipedia/commons/3/3c/Flask_logo.svg", // URL-based image
      },
      {
        name: "MySQL",
        image: "https://upload.wikimedia.org/wikipedia/en/d/dd/MySQL_logo.svg", // URL-based image
      },
      {
        name: "MongoDB",
        image: DB // URL-based image
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg", // URL-based image
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "XML",
        image: XML // URL-based image
      },
      {
        name: "Android Studio",
        image: AS // URL-based image
      },
      {
        name: "Dart",
        image: "https://upload.wikimedia.org/wikipedia/commons/7/7e/Dart-logo.png", // URL-based image
      },
    ],
  },
  {
    title: "Machine Learning",
    skills: [
      {
        name: "Python",
        image: "https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg", // URL-based image
      },
      {
        name: "TensorFlow",
        image: "https://upload.wikimedia.org/wikipedia/commons/2/2d/Tensorflow_logo.svg", // URL-based image
      },
      {
        name: "Jupyter",
        image: "https://upload.wikimedia.org/wikipedia/commons/3/38/Jupyter_logo.svg", // URL-based image
      },
      {
        name: "Google Colab",
        image: "https://upload.wikimedia.org/wikipedia/commons/d/d0/Google_Colaboratory_SVG_Logo.svg", // URL-based image
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image: "https://upload.wikimedia.org/wikipedia/commons/e/e0/Git-logo.svg", // URL-based image
      },
      {
        name: "GitHub",
        image: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png", // URL-based image
      },
      {
        name: "Netlify",
        image: "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png", // URL-based image
      },
      {
        name: "Vercel",
        image: Vercel // URL-based image
      },
      {
        name: "VS Code",
        image: "https://upload.wikimedia.org/wikipedia/commons/9/9a/Visual_Studio_Code_1.35_icon.svg", // URL-based image
      },
      {
        name: "Postman",
        image: "https://upload.wikimedia.org/wikipedia/commons/c/c2/Postman_%28software%29.png", // URL-based image
      },
    ],
  },
];


export const experiences = [
  {
    id: 0,
    img: ibotsImg,  // Use the imported image
    role: "Software Development Engineer",
    company: "Protowiz",
    date: "March 2024 - August 2024",
    desc: "Worked on web development projects using React.js and Node.js. Built a comprehensive dashboard using React leveraging Firebase for real-time data synchronization and authentication. Developed a web application for managing IoT-enabled RO water systems using React.js and Node.js. Successfully integrated Firebase services including authentication and real-time database management across web applications.",
    skills: [
      "ReactJS",
      "NodeJS",
      "AI & ML",
      "Web Development",
      "Firebase",
      "Real-time Device Management",
    ],
  },
];



export const education = [
  {
    id: 0,
    img: College,
    school: "Sri Ramakrishna Engineering College, Coimbatore, India",
    date: "Nov 2020 - May 2024",
    grade: "CGPA: 7.90",
    desc: "Completed a Bachelor of Technology in Artificial Intelligence and Data Science. Developed a strong foundation in AI, machine learning, and data science technologies.",
    degree: "Bachelor of Technology - BTech, Artificial Intelligence and Data Science",
  },
  {
    id: 1,
    img: School,
    school: "Adharsh Vidhyalaya Matric Higher Secondary School, Erode, India",
    date: "2019 - 2020",
    grade: "HSC Score: 75.5%",
    desc: "Completed higher secondary education with a focus on science, achieving 75.5%.",
    degree: "Higher Secondary Certificate (HSC), Science",
  },
  {
    id: 2,
    img: School1,
    school: "GRD-CPF Matric Higher Secondary School, Coimbatore, India",
    date: "2017 - 2018",
    grade: "SSLC Score: 82.6%",
    desc: "Completed secondary school education with a strong focus on academics, achieving a score of 82.6%.",
    degree: "Secondary School Leaving Certificate (SSLC), General",
  }
];



export const projects = [
  {
    id: 0,
    title: "IoT Device Management Web Application for RO Water Systems",
    description:
      "Developed a web application for managing IoT-enabled RO water systems using React.js and Node.js. Implemented real-time device monitoring and control using MQTT protocol and Firebase, reducing manual monitoring efforts by 95% and increasing customer satisfaction by 20%.",
    image: p1,
    tags: ["React", "Node.js", "Firebase", "IoT", "MQTT"],
    category: "web app",
    github: "https://github.com/Baranidharan911"
  },
  {
    id: 1,
    title: "Blockchain Enabled Deep Fake Detection for Multimedia Integrity",
    description:
      "Developed a deep learning-based detection model to identify deep fake content with 98% accuracy. Integrated blockchain technology to ensure data integrity and auditability, achieving 95% traceability of detected content. Utilized smart contracts to automate verification processes, enhancing system efficiency by 25%.",
    image: p2,
    tags: ["Blockchain", "Deep Learning", "AI", "Smart Contracts"],
    category: "machine learning",
    github: "https://github.com/Baranidharan911"
  },
  {
    id: 2,
    title: "House Maintenance System",
    description:
      "Orchestrated the development of a house maintenance system using React.js, Tailwind CSS, and Node.js. Streamlined customer information storage and management through a user-friendly dashboard, increasing productivity by 30% and reducing errors by 20%.",
    image: p3,
    tags: ["React", "Tailwind CSS", "Node.js"],
    category: "web app",
    github: "https://github.com/Baranidharan911"
  },
  {
    id: 3,
    title: "E-Commerce Site",
    description:
      "Developed an e-commerce web application focused on purchasing printing and laminating items. Utilized React, Firebase authentication, and other tools to create a seamless user experience for customers. Improved operational efficiency by centralizing order and customer data.",
    image: p4,
    tags: ["React", "Firebase", "E-Commerce", "Web App"],
    category: "web app",
    github: "https://github.com/Baranidharan911"
  },
  {
    id: 4,
    title: "Admin Dashboard for E-Commerce Platform",
    description:
      "Built an admin dashboard for managing delivery data, payment records, and product inventory for an e-commerce project. Created a user-friendly interface using React and Firebase, resulting in improved control over business operations and a 20% decrease in processing time.",
    image: p5,
    tags: ["React", "Firebase", "Admin Dashboard", "E-Commerce"],
    category: "web app",
    github: "https://github.com/Baranidharan911"
  },
  {
    id: 5,
    title: "Technical Expert Application",
    description:
      "Developed a mobile application using Flutter and Dart to connect individuals with technical experts for software and hardware issues. The app facilitates virtual consultations via text, audio, and video, acting as a mediator and charging users on a time-basis. Firebase was used for backend services.",
    image: p6,
    tags: ["Flutter", "Dart", "Firebase", "Mobile app"],
    category: "android app",
    github: "https://github.com/Baranidharan911"
  },
  {
    id: 6,
    title: "Admin Dashboard",
    description:
      "Created an admin dashboard for managing user data, payment transactions, and other operational aspects of the Technical Expert Connection mobile app. Built using React, Tailwind CSS, and Firebase, enhancing the management experience for admins and reducing operational complexity.",
    image: p7,
    tags: ["React", "Tailwind CSS", "Firebase", "Admin Dashboard"],
    category: "web app",
    github: "https://github.com/Baranidharan911"
  },
  {
    id: 7,
    title: "Payment Dashboard",
    description:
      "Developed a payment management dashboard for a print company with multiple branches. The dashboard centralizes payment data and reduces manual work, providing better financial oversight. Built using React, Firebase, and integrated branch-specific connections to streamline reporting.",
    image: p8,
    tags: ["React", "Firebase", "Payment Dashboard", "Web App"],
    category: "web app",
    github: "https://github.com/Baranidharan911"
  },
  {
    id: 8,
    title: "Hostel Management System",
    description:
      "Developed a web dashboard for managing data of multiple hostels across different locations. Built with React and Firebase, this system helps hostel admins maintain records of residents, payments, and operational details, improving data accuracy and management efficiency.",
    image: p9,
    tags: ["React", "Firebase", "Hostel Management", "Web App"],
    category: "web app",
    github: "https://github.com/Baranidharan911"
  },
  {
    id: 9,
    title: "System Surveillance using Key Logger",
    description:
      "Developed a system surveillance application using a key logger to monitor keyboard activity. Captured keystrokes and sent them to an assigned admin email for monitoring purposes. This project was used to enhance surveillance for assigned systems.",
    image: p10,
    tags: ["Machine Learning", "Surveillance", "Python", "Key Logger"],
    category: "machine learning",
    github: "https://github.com/Baranidharan911"
  },
  {
    id: 10,
    title: "Drowning Detection using YOLOv3",
    description:
      "Created a drowning detection system for swimming pools using computer vision. Utilized YOLOv3 for detecting drowning persons in real time, aimed at avoiding accidents in swimming pools by providing timely alerts.",
    image: p11,
    tags: ["YOLOv3", "Computer Vision", "Python", "Drowning Detection"],
    category: "machine learning",
    github: "https://github.com/Baranidharan911"
  },
  {
    id: 11,
    title: "Diabetes Detection Training Model",
    description:
      "Developed a machine learning training model to detect diabetes based on medical input data. Focused on training data models to achieve a high accuracy rate using common datasets for diabetes detection.",
    image: p12,
    tags: ["Machine Learning", "Healthcare", "Python", "Diabetes Detection"],
    category: "machine learning",
    github: "https://github.com/Baranidharan911"
  },
  {
    id: 12,
    title: "Crop Recommendation System",
    description:
      "Developed a crop recommendation system using machine learning to suggest the best crops based on environmental conditions, soil quality, and weather. This system helps farmers make informed decisions about crop choices to maximize yield.",
    image: p13,
    tags: ["Machine Learning", "Agriculture", "Python", "Crop Recommendation"],
    category: "machine learning",
    github: "https://github.com/Baranidharan911"
  }
];

